// src/api/mockData.js
//
// Placeholder payloads shaped like what the real Node.js API should return.
// Image URLs point at Unsplash placeholders — swap for real asset URLs from
// your backend/CDN. Delete this file once your backend is live; nothing
// else needs to change as long as responses match these shapes.

export const mockAnnouncement = {
  id: 'ann_2024_05',
  emoji: '🎉',
  message: 'Welcome to IBiz Accounts  !',
  ctaLabel: 'View All',
  ctaUrl: '/announcements',
};

export const mockValueProps = [
  { id: 'v1', icon: 'lock', color: 'blue', title: 'Secure Access', sub: 'Bank-grade security for your data' },
  { id: 'v2', icon: 'clock', color: 'green', title: 'Accurate Payroll', sub: 'Process payroll with 99.9% accuracy' },
  { id: 'v3', icon: 'file', color: 'purple', title: 'Self Service', sub: 'Employees manage their information' },
  { id: 'v4', icon: 'smartphone', color: 'orange', title: 'Mobile Friendly', sub: 'Access anytime, anywhere' },
];

// A rotating list of featured subscriber businesses.
export const mockSpotlights = [
  {
    id: 'sp_sri_lakshmi',
    companyName: 'Sri Lakshmi Foods',
    tagline: 'Manufacturers of Premium Spices',
    description: 'Serving South India Since 1995',
    logoInitials: 'SL',
    backgroundImage: 'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?w=1200&q=80',
    qrLabel: 'Scan to visit Website',
    qrUrl: 'https://srilakshmifoods.example.com',
    ctaUrl: '/subscribers/sri-lakshmi-foods',
    stats: [
      { label: 'Years of Excellence', value: '20+' },
      { label: 'Happy Customers', value: '500+' },
      { label: 'ISO 22000', value: 'Certified' },
    ],
  },
  {
    id: 'sp_greenfield',
    companyName: 'Greenfield Textiles',
    tagline: 'Sustainable Fabric Manufacturers',
    description: 'Exporting Since 2004',
    logoInitials: 'GT',
    backgroundImage: 'https://images.unsplash.com/photo-1558769132-cb1aea458c5e?w=1200&q=80',
    qrLabel: 'Scan to visit Website',
    qrUrl: 'https://greenfieldtextiles.example.com',
    ctaUrl: '/subscribers/greenfield-textiles',
    stats: [
      { label: 'Years in Business', value: '22+' },
      { label: 'Global Clients', value: '120+' },
      { label: 'GOTS', value: 'Certified' },
    ],
  },
  {
    id: 'sp_nova',
    companyName: 'Nova Pharma Labs',
    tagline: 'Generic Pharmaceuticals',
    description: 'Trusted Across 14 States',
    logoInitials: 'NP',
    backgroundImage: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=1200&q=80',
    qrLabel: 'Scan to visit Website',
    qrUrl: 'https://novapharmalabs.example.com',
    ctaUrl: '/subscribers/nova-pharma-labs',
    stats: [
      { label: 'Years of Excellence', value: '15+' },
      { label: 'Products', value: '80+' },
      { label: 'WHO-GMP', value: 'Certified' },
    ],
  },
];

export const mockUpdates = [
  { id: 'u1', title: 'New CRM Features', subtitle: 'Advanced lead tracking & pipeline view', tag: 'NEW', icon: 'layout' },
  { id: 'u2', title: 'Inventory Updates', subtitle: 'Batch tracking & low stock alerts', tag: 'NEW', icon: 'package' },
  { id: 'u3', title: 'HRMS Enhancements', subtitle: 'Performance appraisal & OKR module', tag: 'NEW', icon: 'users' },
  { id: 'u4', title: 'AI Tools', subtitle: 'AI Assistant for HR & Payroll Queries', tag: 'NEW', icon: 'sparkles' },
];

export const mockEvents = [
  { id: 'e1', day: '28', month: 'MAY', title: 'Webinar: Payroll Compliance Updates 2024', time: '04:00 PM - 05:00 PM' },
  { id: 'e2', day: '05', month: 'JUN', title: 'Product Launch: AI Assistant for HR & Payroll', time: '11:00 AM - 12:00 PM' },
  { id: 'e3', day: '12', month: 'JUN', title: 'Training Session: Getting Started with Self Service', time: '03:00 PM - 04:00 PM' },
];

export const mockNetworkStats = [
  { id: 'n1', label: 'Businesses', value: '550+', icon: 'briefcase' },
  { id: 'n2', label: 'Employees', value: '150,000+', icon: 'users' },
  { id: 'n3', label: 'Industries', value: '12+', icon: 'layers' },
  { id: 'n4', label: 'Payroll Accuracy', value: '99.9%', icon: 'bar-chart' },
];

export const mockOffers = [
  {
    id: 'o1',
    title: '10% Discount',
    subtitle: 'on Office Furniture',
    tag: 'For Our Customers',
    icon: 'tag',
    image: 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=200&q=80',
  },
  {
    id: 'o2',
    title: 'Special Pricing',
    subtitle: 'on Medical Equipment',
    tag: 'For Our Customers',
    icon: 'heart',
    image: 'https://images.unsplash.com/photo-1584982751601-97dcc096659c?w=200&q=80',
  },
  {
    id: 'o3',
    title: 'Free GST Consultation',
    subtitle: 'For First Time Customers',
    tag: '',
    icon: 'file-text',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&q=80',
  },
   {
    id: 'o4',
    title: 'Special Pricing',
    subtitle: 'on Medical Equipment',
    tag: 'For Our Customers',
    icon: 'heart',
    image: 'https://images.unsplash.com/photo-1584982751601-97dcc096659c?w=200&q=80',
  },
    {
    id: 'o5',
    title: '10% Discount',
    subtitle: 'on Office Furniture',
    tag: 'For Our Customers',
    icon: 'tag',
    image: 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=200&q=80',
  },
];

export const mockSolutions = [
  { id: 'sol1', label: 'Rollcall', sub: 'Attendance', icon: 'users', color: 'blue' },
  { id: 'sol2', label: 'Payroll', sub: 'Management', icon: 'indian-rupee', color: 'green' },
  { id: 'sol3', label: 'CRM', sub: 'Management', icon: 'handshake', color: 'purple' },
  { id: 'sol4', label: 'Inventory', sub: 'Management', icon: 'box', color: 'orange' },
  { id: 'sol5', label: 'Visitor', sub: 'Management', icon: 'id-card', color: 'blue' },
  { id: 'sol6', label: 'Mobile App', sub: '(Android & iOS)', icon: 'smartphone', color: 'navy' },
  { id: 'sol7', label: 'AI Assistant', sub: 'Smart Support', icon: 'bot', color: 'purple' },
  { id: 'sol8', label: 'WhatsApp', sub: 'Integration', icon: 'message-circle', color: 'green' },
];

export const mockTrustBar = [
  { id: 't1', title: 'Secure & Compliant', sub: 'ISO 27001 Certified', icon: 'shield-check' },
  { id: 't2', title: 'Reliable Support', sub: "We're here to help", icon: 'headset' },
  { id: 't3', title: 'Data Privacy', sub: 'Your data is safe with us', icon: 'lock' },
  { id: 't4', title: '24/7 Availability', sub: 'Access anytime, anywhere', icon: 'clock' },
];

export const mockFooterSummary = {
  businesses: '550+',
  label: 'Businesses Trust Our Solutions',
};

export function delay(ms = 500) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
